
export const stripeKey = ((env: 'test' | 'prod') => {
    const keys = {
        test: 'pk_test_51HuApbDhVgAK9zLvS58yT12ywJ6L3Mjoo1aPfwMSBcaJUxnVw2jesFki29HMREDHNBGsoMmXeFuN98BkPnusTSp200TiaRk1tP',
        prod: 'pk_live_51HuApbDhVgAK9zLvDcYUm2HHLneww4x2h8fpU89kZVR1qclGlZovQkycbbPf2IP3PekattHzvQRp2TpLCS4AWHL300gSV463em'
    }
    console.log(`PUBLIC KEY: ${env}`)
    return keys[env];
})('prod')